import { cloneDeep } from 'lodash';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { delay } from 'rxjs/operators';
import moment from 'moment';

import { Activity, Address, Country, FullClient } from '../../../domain/data';
import { ActivityAge, DocumentType, GetActivitiesUseCase, GetCountriesUseCase, LegalSourceIncome, Volume } from '../../../../core';
import { BaseUI } from '../../base.ui';
import { ErrorDialog } from '../../dialog/error/error.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';
import { ParentFormDirective } from '../../../directives/parent-form.directive';

import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'thr-full-data-one-legal-person',
    templateUrl: './full-data-one-legal-person.component.html',
    styleUrls: ['./full-data-one-legal-person.component.scss'],
})
export class FullDataOneLegalPersonComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public ActivityAge: typeof ActivityAge = ActivityAge;
    public DocumentType: typeof DocumentType = DocumentType;
    public LegalSourceIncome: typeof LegalSourceIncome = LegalSourceIncome;
    public Volume: typeof Volume = Volume;

    public form: NgForm;
    public isFormValid = false;

    public activities: Activity[] = [];
    public countries: Country[] = [];
    public isClientPortal = environment.portalClient;
    public today = moment();
    public isValidator: boolean = undefined;

    @Input()
    client: FullClient;

    @Input()
    isDisabled = false;

    @Input()
    isDisabledSubmit = false;

    @ViewChild('formDirective')
    formDirective: ParentFormDirective;

    constructor(
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private getActivitiesUseCase: GetActivitiesUseCase,
        private getCountriesUseCase: GetCountriesUseCase
    ) {
        super(parentEvents);
    }

    ngOnInit() {
        if (localStorage.getItem('RolName') == 'Validador') {
            this.isValidator = true;
        } else {
            this.isValidator = false;
        }

        this.getActivities();
        this.getCountries();
    }

    private getActivities() {
        this.getActivitiesUseCase
            .bind()
            .pipe(delay(1))
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.activities = transaction.data as Activity[];
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    private getCountries() {
        this.getCountriesUseCase
            .bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.countries = transaction.data as Country[];
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.form = this.formDirective.controlContainer as NgForm;

        if (this.form) {
            this.form.statusChanges.subscribe(() => {
                setTimeout(() => {
                    this.isFormValid = this.form.valid;
                });
            });
        }
    }

    onLegalResidenceChange() {
        if (this.client.isEqualMailAddress) {
            this.client.mailResidence = cloneDeep(this.client.legalResidence);
        }
    }

    onEqualMailAddressChange() {
        if (this.client.isEqualMailAddress) {
            this.client.mailResidence = cloneDeep(this.client.legalResidence);
        } else {
            this.client.mailResidence = new Address();
        }

        this.parentEvents.resize();
    }

    onResize() {
        this.parentEvents.resize();
    }
}
